import { QueryClient } from '@tanstack/react-query';

import { GC_TIME_DEFAULT_MS } from '../queries/staleTimes';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: GC_TIME_DEFAULT_MS,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
